export const USER_ACTION = {
  LOGOUT: 'logout'
}

// this contains the constants related to web storages
export const STORAGE_KEYS = {
  krsViewType: 'krsViewType',
  initiativeModalTipDismissed: 'initiativeModalTipDismissed',
  checkinSnoozedAt: 'checkinSnoozedAt',
  visitedTours: 'visitedTours',
  goalFeedPreference: 'goalFeedPreference',
  keyResultFeedPreference: 'keyResultFeedPreference',
  initiativeFeedPreference: 'initiativeFeedPreference',
  ideaFeedPreference: 'ideaFeedPreference',
  ideaModalTipDismissed: 'ideaModalTipDismissed',
  introsSeen: 'introsSeen',
  initiativeLists: 'initiativeLists2',
  initiativeListsMigrationFlag: 'initiativeListsMigrationFlag',
  newestAnnouncementReadDate: 'newestAnnouncementReadDate',
  announcement: 'announcement',
  newNotificationTooltipDismissed: 'newNotificationTooltipDismissed',
  flags: 'flags',
  goalTemplate: 'goalTemplate',
  teamFilterPreference: 'teamFilterPreference',
  myWorkInitiativesFilters: 'myWorkInitiativesFilters',
  onboardingFlowType: 'onboardingFlowType',
  onboardingAccountType: 'onboardingAccountType',
  sidebarWidth: 'sidebarWidth',
  sidebar: {
    _key: 'sidebar',
    flags: {
      _key: 'flags',
      teamsExpanded: {
        _key: 'teamsExpanded',
        defaultValue: true,
        expiresOn: USER_ACTION.LOGOUT
      },
      starredTeamsExpanded: {
        _key: 'starredTeamsExpanded',
        defaultValue: true,
        expiresOn: USER_ACTION.LOGOUT
      },
      listsExpanded: {
        _key: 'listsExpanded',
        defaultValue: false,
        expiresOn: USER_ACTION.LOGOUT
      },
      connectToChatWidgetDismissed: {
        _key: 'connectToChatWidgetDismissed'
      }
    }
  },
  userContent: 'userContent'
}

export const STORAGE_FLAGS = {
  onboardingBannerDismissed: 'onboardingBannerDismissed',
  templateTeamFilterSeen: 'templateTeamFilterSeen',
  needHelpBannerDismissed: 'needHelpBannerDismissed'
}
